export class EnaioClientType {
    id = "";
    name = "";
}
